<script setup>
import {
    nextTick,
} from 'vue';
import { usePrimeVue } from 'primevue/config';
import { useLayout } from '@/layout/admin/composables/layout';
import emitter from '@/config/emitter.js'

const { layoutConfig } = useLayout();
const $primevue = usePrimeVue();

const onChangeTheme = (theme, mode) => {
    $primevue.changeTheme(layoutConfig.theme.value, theme, 'theme-css', () => {
        layoutConfig.theme.value = theme;
        layoutConfig.darkTheme.value = mode;
    });
};

const onDarkModeChange = (value) => {
    const newThemeName = value ? layoutConfig.theme.value.replace('light', 'dark') : layoutConfig.theme.value.replace('dark', 'light');

    layoutConfig.darkTheme.value = value;
    onChangeTheme(newThemeName, value);
    nextTick(() => {
        emitter.emit('dark-theme-switch', value)
    })
};
</script>
<template>
    <div class="flex">
        <button
            type="button"
            class="flex flex-shrink-0 px-link border-1 border-solid w-2rem h-2rem surface-border border-round surface-card align-items-center justify-content-center transition-all transition-duration-300 hover:border-primary"
            @click="onDarkModeChange(!layoutConfig.darkTheme.value)"
        >
            <i class="pi text-700" :class="{ 'pi-moon': layoutConfig.darkTheme.value, 'pi-sun': !layoutConfig.darkTheme.value }"></i>
        </button>
    </div>
</template>

<script>
export default {
    name: 'DarkmodeSwitcherComponent'
};
</script>
